
import { generateID } from '@/common/utils/helpers';
import { computed, defineComponent, type PropType } from 'vue';

export enum CheckboxType {
    Default = 'default',
    ICheck = 'icheck',
    Custom = 'custom'
}

type CheckboxTypeValue = CheckboxType | `${CheckboxType}`;

const CHECKBOX_CLASS_MAP = {
    [CheckboxType.ICheck]: {
        container: 'icheck-primary',
        input: '',
        label: ''
    },
    [CheckboxType.Custom]: {
        container: 'custom-control custom-checkbox',
        input: 'custom-control-input',
        label: 'custom-control-label'
    },
    [CheckboxType.Default]: {
        container: 'form-check',
        input: 'form-check-input',
        label: 'form-check-label'
    }
} as const;

export default defineComponent({
    name: 'AppCheckbox',
    props: {
        modelValue: { type: Boolean, default: false },
        type: { type: String as PropType<CheckboxTypeValue>, default: CheckboxType.Default },
        label: { type: String, default: '' }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const ID = generateID();
        const classes = computed(() => CHECKBOX_CLASS_MAP[props.type] ?? CHECKBOX_CLASS_MAP[CheckboxType.Default]);

        const onValueChange = (event: Event): void => {
            const target = event.target;
            if (!(target instanceof HTMLInputElement)) {
                return;
            }

            emit('update:modelValue', target.checked);
        };

        return { ID, classes, onValueChange };
    }
});
